import React from 'react';
import { AnimatedSection } from './ui/AnimatedSection';
import { Button } from './ui/Button';
import { FileText, Target, Wallet } from 'lucide-react';
export const OfferBlock = () => {
  return <AnimatedSection id="oferta" className="bg-sepia/30 border-t border-ink/10 pb-24" data-id="element-90">
      <div className="max-w-4xl mx-auto" data-id="element-91">
        {/* The Certificate / Offer Card */}
        <div className="bg-paper border-2 border-ink p-8 md:p-12 relative shadow-2xl" data-id="element-92">
          {/* Decorative corners */}
          <div className="absolute top-2 left-2 w-4 h-4 border-t-2 border-l-2 border-ink/30" data-id="element-93"></div>
          <div className="absolute top-2 right-2 w-4 h-4 border-t-2 border-r-2 border-ink/30" data-id="element-94"></div>
          <div className="absolute bottom-2 left-2 w-4 h-4 border-b-2 border-l-2 border-ink/30" data-id="element-95"></div>
          <div className="absolute bottom-2 right-2 w-4 h-4 border-b-2 border-r-2 border-ink/30" data-id="element-96"></div>

          <div className="text-center space-y-8" data-id="element-97">
            <h2 className="text-3xl md:text-5xl font-serif text-ink leading-tight" data-id="element-98">
              Dejá de ver cómo tus ahorros pierden valor cada día.
            </h2>

            <p className="text-lg md:text-xl font-sans text-ink/80 max-w-2xl mx-auto" data-id="element-99">
              Llevate hoy El Manual del Appointment Setter y empezá a construir
              tu puente al dólar por un pago único.
            </p>

            <div className="py-8 border-y border-ink/10 my-8" data-id="element-100">
              <span className="uppercase tracking-widest text-xs font-semibold text-ink/50 block mb-2" data-id="element-101">
                INVERSIÓN
              </span>
              <div className="flex flex-col items-center justify-center" data-id="element-102">
                <span className="text-5xl md:text-7xl font-serif text-accent mb-2" data-id="element-103">
                  $24.900 ARS
                </span>
                <div className="flex gap-4 text-sm font-sans text-ink/60 uppercase tracking-wider" data-id="element-104">
                  <span data-id="element-105">Pago único</span>
                  <span data-id="element-106">·</span>
                  <span data-id="element-107">Acceso inmediato</span>
                </div>
              </div>
            </div>

            <div className="space-y-4" data-id="element-108">
              <Button href="#" className="w-full md:w-auto text-lg md:text-xl py-5 px-12 shadow-xl shadow-accent/20" data-id="element-109">
                ¡QUIERO EMPEZAR A COBRAR EN DÓLARES YA!
              </Button>
              <p className="text-sm font-sans text-ink/60 italic" data-id="element-110">
                Acceso inmediato al PDF tras la confirmación del pago.
              </p>
            </div>

            {/* Trust Badges */}
            <div className="flex flex-wrap justify-center gap-6 md:gap-12 pt-8 mt-8 border-t border-ink/10" data-id="element-111">
              <div className="flex items-center gap-2 text-ink/70" data-id="element-112">
                <FileText size={18} data-id="element-113" />
                <span className="text-sm font-sans" data-id="element-114">PDF Descargable</span>
              </div>
              <div className="flex items-center gap-2 text-ink/70" data-id="element-115">
                <Target size={18} data-id="element-116" />
                <span className="text-sm font-sans" data-id="element-117">Estrategia Probada</span>
              </div>
              <div className="flex items-center gap-2 text-ink/70" data-id="element-118">
                <Wallet size={18} data-id="element-119" />
                <span className="text-sm font-sans" data-id="element-120">Pago Seguro</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </AnimatedSection>;
};